import { render, staticRenderFns } from "./sample1.vue?vue&type=template&id=08e4ae58&scoped=true&"
var script = {}
import style0 from "./sample1.vue?vue&type=style&index=0&id=08e4ae58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e4ae58",
  null
  
)

export default component.exports